var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('g',[_c('circle',{staticClass:"fill-secondary",attrs:{"cx":"12","cy":"12","r":"10"}}),_c('path',{attrs:{"fill":"white","d":"M14 10h2a1 1 0 0 1 .81 1.58l-5 7A1 1 0 0 1 10 18v-4H8a1 1 0 0 1-.81-1.58l5-7A1 1 0 0 1 14 6v4z"}})])}
var staticRenderFns = []

export { render, staticRenderFns }